import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createGift(context, giftData) {
    return new Promise((resolve, reject) => {
      axios
        .post('gifts', giftData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  generateGift(context, giftData) {
    return new Promise((resolve, reject) => {
      axios
        .post('gifts/generate', giftData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  receiveGift(context, giftData) {
    return new Promise((resolve, reject) => {
      axios
        .post('gifts/receive', giftData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countGifts(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`gifts/count/?${query}`)
        .then(response => {
          context.commit('SET_Gift_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  getGiftCode() {
    return new Promise((resolve, reject) => {
      axios
        .get('gifts/code')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchGifts(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`gifts/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('SET_Gift', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchGift(context, giftId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`gifts/${giftId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeGift({ commit }, giftId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`gifts/${giftId}`)
        .then(response => {
          commit('REMOVE_RECORD', giftId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editGift(context, gift) {
    return new Promise((resolve, reject) => {
      axios
        .put(`gifts/${gift.id}`, gift.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
